






















import { Component, Vue } from 'vue-property-decorator';

import Tabs from '@/componentsV2/molecules/Tabs/Tabs.vue';

import {
  ECustomerInactivityTabs,
  ICustomerInactivityInfoTab
} from '@/models/customer-inactivity';

@Component({
  components: {
    Tabs
  }
})
export default class CustomerInactivityInfoTabs extends Vue {
  activeTabSlug: ECustomerInactivityTabs = ECustomerInactivityTabs.MOBILE_APP;

  get tPrefixSpecialCoinTerm() {
    return `common.specialCoin`;
  }

  get tabMapper(): {
    [k: string]: ICustomerInactivityInfoTab;
  } {
    return {
      [ECustomerInactivityTabs.MOBILE_APP]: {
        label: 'Mobile App',
        list: [
          'Receive Loyalty Coins for purchases at your store or website',
          'Pay with Coins at your store',
          'Save an Offer',
          'Use an Offer',
          'Claim Welcome Coins',
          'Send Gift Coins',
          'Accept Gift Coins',
          'Receive Coins or Offers from you through Award Coins'
        ],
        observation:
          'Obs: The Twism Mobile App is available only for in-store and online businesses from the United States.'
      },
      [ECustomerInactivityTabs.ONLINE_WIDGET]: {
        label: 'Online Widget',
        list: [
          'Receive Loyalty Coins for purchases on your website',
          'Convert Coins into a payment code',
          'Claim Welcome Coins',
          'Receive Coins or Offers from you through Award Coins'
        ],
        observation:
          'Obs: The Twism Online Widget is available only for online businesses using Wix, Shopify, WooCommerce or BigCommerce.'
      }
    };
  }

  get tabs() {
    return Object.entries(this.tabMapper).map(([key, value]) => ({
      key,
      label: value.label
    }));
  }

  get hideTabs() {
    return window.location.pathname.includes('/portal/');
  }

  handleTabChanges(tab: ECustomerInactivityTabs) {
    if (tab !== this.activeTabSlug) {
      this.activeTabSlug = tab;
    }
  }
}
